import styled from 'styled-components'
import { mobileMax } from '../../constants'

const FooterStyled = styled.div`
    background-color: #2D2D2D;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding: 0;
    

    .footer-logo {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .footer-logo img {
        color: #ffffff;
        width: 120px;
        max-width: 100%;
        font-weight: 600;
        display: block;
        margin: 0 auto;
    }
    .footer-contact {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
        margin-left: 1rem;
        margin-bottom: 1rem;
    }

    @media ${mobileMax} {
        
        padding-bottom: 70px;
        .footer-logo {
            margin-top: 24px;
            margin-bottom: 16px;
        }
        .footer-logo img {
            width: 40vw;
            min-width: 120px;
            max-width: 200px;
        }
        .footer-contact {
            margin-left: 0.5rem;
            margin-bottom: 1.5rem;
            gap: 0.7rem;
        }
    }
`

export { FooterStyled }
